import { dashboard } from './dashboard';
import { project } from './project';
import { utilities } from './utilities';
import { other } from './other';

//-----------------------|| MENU ITEMS ||-----------------------//

const menuItems = {
    items: [dashboard, project, other]
};

export default menuItems;
